/* Publish by EComposer at 2026-09-30 06:43:28*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-vd2zrphfsd"]=  window.__ectimmers["ecom-vd2zrphfsd"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-vd2zrphfsd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vd2zrphfsd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ryyp3iv7yzc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ryyp3iv7yzc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r36zcx1fsuo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r36zcx1fsuo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lvgux4lm9k8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lvgux4lm9k8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cr2onnibrlo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cr2onnibrlo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q36lgz8cee9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q36lgz8cee9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ypfsympzxzg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ypfsympzxzg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sgtckex3ud').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sgtckex3ud', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vxhbt17bov').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vxhbt17bov', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nnb7bvuwzor').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nnb7bvuwzor', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-py723yeon2c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-py723yeon2c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qoxps66y4y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qoxps66y4y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pmaev5ltev').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pmaev5ltev', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tkbs5pp6ntj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tkbs5pp6ntj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ed8b059d3t7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ed8b059d3t7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-98y5lcno2e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-98y5lcno2e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lfw5obf4dkd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lfw5obf4dkd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qg9ufwhkt8q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qg9ufwhkt8q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s10v2ujmalr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s10v2ujmalr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xriatmdub2h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xriatmdub2h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kd90ghj8bmh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kd90ghj8bmh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-80veqzcy2dn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-80veqzcy2dn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-51892sr21vy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-51892sr21vy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oyog8nlxm9r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oyog8nlxm9r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-trhsyuztdj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-trhsyuztdj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h2jodcywko8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h2jodcywko8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-54u4tml2vk4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-54u4tml2vk4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9qiqr821t7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9qiqr821t7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yo3jwvxa1dt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yo3jwvxa1dt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ocsle0hzhes').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ocsle0hzhes', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8x7y13nbuo2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8x7y13nbuo2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wpquqcdl57t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wpquqcdl57t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lewqems6v4d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lewqems6v4d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d6pv2t7zsdc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d6pv2t7zsdc', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2l0a89mslln"]=  window.__ectimmers["ecom-2l0a89mslln"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-2l0a89mslln"]["neijd6s3l"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-2l0a89mslln').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2l0a89mslln', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8rygh0qggq7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8rygh0qggq7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hasdw0wt65d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hasdw0wt65d', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m0hp7ftdy8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m0hp7ftdy8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3alhnwx7xh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3alhnwx7xh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9jn5x7ic977').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9jn5x7ic977', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ulx1tsbxbi9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ulx1tsbxbi9', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}